<template>
   <div class="block-edit-process">
       <form id="form-process-affair-add" v-on:submit.prevent="validateBeforeSubmit">
        <div class="row"> 
            <div class="col-12 control">
                <ejs-autocomplete id="themeListSelect" name="themeListSelect" ref='themeListSelect' data-msg-containerid="formProcessAffairError1" v-model="themeListSelect" floatLabelType="Auto" :dataSource='dataSourceThemesSearch' :fields='fieldsTheme' :showPopupButton='true' cssClass="e-outline" :change="onSelectTheme" :placeholder="$t('textAffairAssociation.textAffairGrid.theme')" suggestionCount="10000"></ejs-autocomplete>
                <div id="formProcessAffairError1"></div>
            </div>
            <div class="col-12 control">
                <ejs-autocomplete id="subThemeListSelect" name="subThemeListSelect" ref='subThemeListSelect' data-msg-containerid="formProcessAffairError2" v-model="subThemeListSelect" floatLabelType="Auto" :dataSource='dataSourceSubThemesSearch' :fields='fieldsSubTheme' :showPopupButton='true' cssClass="e-outline" :change="onSelectSubTheme" :placeholder="$t('textAffairAssociation.textAffairGrid.subtheme')" :enabled=false suggestionCount="10000"></ejs-autocomplete>
                <div id="formProcessAffairError2"></div>
            </div>
            <div class="col-12 control">
                <ejs-autocomplete id="affairListSelect" name="affairListSelect" ref='affairListSelect' data-msg-containerid="formProcessAffairError3" v-model="affairListSelect" floatLabelType="Auto" :dataSource='dataSourceAffairs' :fields='fieldsAffair' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textAffairAssociation.textAffairGrid.affair')" :enabled=false suggestionCount="10000"></ejs-autocomplete>
                <div id="formProcessAffairError3"></div>
            </div>
            <div class="col-12 control">
                <ul class="list-group list-group-horizontal justify-content-start border-enable">
                    <li  class="list-group-item mr-4"><ejs-checkbox id="interestCheck" :label="$t('textAffairAssociation.textAffairGrid.interest')" v-model="interest" name="status" cssClass='e-primary'></ejs-checkbox></li>
                </ul>
            </div>
            <div class="col-4 control">
                <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtnFormAffair" :spinSettings="spinSettings">{{ $t('textProcessesStructure.textSave') }}</ejs-progressbutton>
            </div>
        </div>
       </form>
   </div>
</template>

<script>
import axios from 'axios'
import { Predicate, Query } from '@syncfusion/ej2-data';
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
Vue.use(ProgressButtonPlugin);

export default {
   name: "processes-detail-process-affair-add",
   props: ["data"],
	data () {
		return {
            themeListSelect: '',
            subThemeListSelect: '',
            affairListSelect: '',
            dataSourceThemesSearch: [],
            dataSourceSubThemesSearch: [],
            dataSourceAffairs: [],
            fieldsTheme: { value: "tema" },
            fieldsSubTheme: { value: "subtema" },
            fieldsAffair: { value: "asunto" },
            interest: false,
            disabledButton :false,
            spinSettings: { position: 'Right', width: 20 },
            optionsFormAffair: {
                rules: {
                    'themeListSelect': {	
                        required: [true, "* Campo tema requerido."]
                    },	
                    'subThemeListSelect': {	
                        required: [true, "* Campo subtema requerido."],
                    },
                    'affairListSelect': {	
                        required: [true, "* Campo asunto requerido."]
                    },
                }
            }
        }
    },
    mounted: function () {
        this.formObjAffair = new FormValidator('#form-process-affair-add', this.optionsFormAffair);
    },
	methods: {
		initProcessAffairAdd: function() {
            axios.post('/auth/norms/getInitialInfoNorms', {}).then(response => {
                this.dataSourceThemesSearch = response.data.themes;
                this.dataSourceSubThemesSearch = response.data.subthemes;
            });

            axios.post('/auth/processes/getAffairNotInProcessStructure', {processId: this.$route.params.id}).then(response => {
                this.dataSourceAffairs = response.data;
            });

        },
        onCancel: function(){
            Vue.prototype.$eventHub.$emit('closeSidebarClick');
        },
        validateBeforeSubmit: function(){
            let formStatus = this.formObjAffair.validate();
            if (formStatus) {
                this.disabledButton = true;
                this.$refs.progressBtnFormAffair.enable;
                var theme = document.getElementById("themeListSelect").ej2_instances[0].itemData.id;
                var subTheme = document.getElementById("subThemeListSelect").ej2_instances[0].itemData.id;
                var affair = document.getElementById("affairListSelect").ej2_instances[0].itemData.id;
                var interest = ((document.getElementById("interestCheck").checked) ? 1 : 0);

                axios.post('/auth/processes/storeAffairProcess', 
                {
                    processId : this.$route.params.id,
                    themeId   : theme,
                    subThemeId: subTheme,
                    affairId  : affair,
                    interest  : interest
                }
                ).then(response => {
                    this.disabledButton = false;
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    if(response.data.status == 'success') {
                        this.formObjAffair.element.reset();
                        Vue.prototype.$eventHub.$emit('onResetAffairAssociation');
                        Vue.prototype.$eventHub.$emit('closeSidebarClick');
                    }
                });
            }
            else{
                this.$refs.progressBtnFormAffair.stop();
            }
        },
        onSelectTheme: function(args){
            if(args.value !== null)
            {
                let predicate = new Predicate('tema_id', 'equal', args.itemData.id);
                let flSearchSubTheme = document.getElementById("subThemeListSelect").ej2_instances[0];
                flSearchSubTheme.query = new Query().where(predicate);
                flSearchSubTheme.enabled = true;
            }
            else
            {
                let flSearchSubTheme = document.getElementById("subThemeListSelect").ej2_instances[0];
                flSearchSubTheme.value = null;
                flSearchSubTheme.enabled = false;
            }
        },
        onSelectSubTheme: function(args){
            if(args.value !== null)
            {
                let predicate = new Predicate('tema_id', 'equal', args.itemData.tema_id);
                predicate = predicate.and('subtema_id', 'equal', args.itemData.id);
                let flSearchAffair = document.getElementById("affairListSelect").ej2_instances[0];
                flSearchAffair.query = new Query().where(predicate); 
                flSearchAffair.enabled = true;
            }
            else
            {
                let flSearchAffair = document.getElementById("affairListSelect").ej2_instances[0];
                flSearchAffair.value = null;
                flSearchAffair.enabled = false;
            }
        },
        progress: function() {
            if(this.disabledButton == false){
                this.$refs.progressBtnFormAffair.stop();
            }
        }
	},
	created: function() {
        this.initProcessAffairAdd();
        this.$eventHub.$on('onResetSwitchTenants', this.onCancel);
    }
}
</script>